module.exports = __webpack_public_path__ + "img/tabs1-2.1478e45e.png";